import type { BillingSubscriptionPlan, BillingSubscriptionPriceKey, BillingSubscriptionProduct } from '../types/billing';

const SUBSCRIPTION_PLANS = {
  monthly_subscription: { plan: 'pro', interval: 'monthly' },
  annual_subscription: { plan: 'pro', interval: 'annual' },
  enterprise_monthly_subscription: { plan: 'enterprise', interval: 'monthly' },
  enterprise_annual_subscription: { plan: 'enterprise', interval: 'annual' },
} as const;

export function isBillingSubscriptionPriceKey(value: unknown): value is BillingSubscriptionPriceKey {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(SUBSCRIPTION_PLANS, value);
}

export function getBillingSubscriptionInterval(priceKey: BillingSubscriptionPriceKey): BillingSubscriptionProduct['interval'] {
  return SUBSCRIPTION_PLANS[priceKey].interval;
}

export function getBillingSubscriptionPlan(product: Pick<BillingSubscriptionProduct, 'priceKey'>): BillingSubscriptionPlan {
  return SUBSCRIPTION_PLANS[product.priceKey].plan;
}

export function isConsistentSubscriptionProduct(product: { priceKey: unknown; interval: unknown; plan?: unknown }): boolean {
  if (!isBillingSubscriptionPriceKey(product.priceKey)) return false;
  const expected = SUBSCRIPTION_PLANS[product.priceKey];
  return product.interval === expected.interval && (product.plan === undefined || product.plan === expected.plan);
}

export function subscriptionsForPlan(products: readonly BillingSubscriptionProduct[], plan: BillingSubscriptionPlan): BillingSubscriptionProduct[] {
  return products.filter((product) => isConsistentSubscriptionProduct(product) && getBillingSubscriptionPlan(product) === plan);
}
